export default __webpack_public_path__ + "static/media/Salaries@32.4247c161.svg";